import Search from "./Search";
import Filter from "./Filter";
import Body from "./Body";
import Update from "./Update";

const Components = {
  Search,
  Filter,
  Body,
  Update,
};

export default Components;
